import FloatingEditorContainer from './FloatingEditorContainer';
import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FloatingManager extends Component {

  render() {

    const { project, data, graph, entitlements, ontologyProjects, projectUsers } = this.props;

    return (
      <ProjectProvider value={this.props.data}>
        <FloatingEditorContainer
          location={this.props.location}
          entitlements={entitlements}
          project={project}
          graph={graph}
          projectUsers={projectUsers}
          ontologyProjects={ontologyProjects}
          skosXL={data.skosXL || false}
          defaultLang={data.defaultLang} />
      </ProjectProvider>
    );
  }
}

FloatingManager.propTypes = {
  entitlements: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  projectUsers: PropTypes.array,
  ontologyProjects: PropTypes.array,
  project: PropTypes.string.isRequired
};

export default FloatingManager;
